export default class EditorFormType
{
	static Non = -1;
	static FormModule = 0;
	static QueryForm = 1;
	static Report = 2;
	static Dialog = 3;
	static FormLookup = 4;
}


// WEBPACK FOOTER //
// ./src/utils/EditorFormType.js